{
  "overlay": {
    "viewArchive": {
      "title": "View Archive",
      "description": "See past issues here"
    },
    "startReading": {
      "title": "Start reading",
      "description": "Read today's issue with this button"
    }
  },
  "tutorials": [
    {
      "title": "Let's get started",
      "body": "Enjoy a better experience with quick access, archives and an expanded article view. Find out more about the features in the tutorial."
    },
    {
      "title": "Expanded article view",
      "body": "Click an article to open an expanded view that is easier to read. (For paid subscribers only)",
      "bodyFree": "Click an article to open an expanded view that is easier to read."
    },
    {
      "title": "Read past issues",
      "body": "Access past editions of the e-paper here"
    },
    {
      "title": "Quick access to all pages",
      "body": "Preview and go to other pages or sections quickly"
    },
    {
      "title": "Browse more editions",
      "body": "Stay on top of things by catching up on any issues you might have missed"
    },
    {
      "title": "Image download",
      "body": "Save the page as image to your device"
    },
    {
      "title": "Article sharing",
      "body": "Tap the share icon to send a link"
    },
    {
      "title": "Toggle between views",
      "body": "Switch between article and print view using the toggle"
    }
  ]
}
